import React from 'react';

// A foto que a gerente sobe no catálogo/pôster vai como sugestão pro cadastro de
// produto do Portal Comercial (backend/src/services/fotoSugestao.js). Aqui ela
// vê isso e o que o comercial decidiu da última foto sugerida desse produto.
const SITUACAO = {
  pendente: { txt: 'enviada, esperando o comercial abrir', cor: '#A88A3A', icone: 'hourglass-split' },
  recebida: { txt: 'no comercial, esperando decisão', cor: '#A88A3A', icone: 'hourglass-split' },
  aprovada: { txt: 'aprovada — já está no cadastro do produto', cor: '#198754', icone: 'check-circle' },
  rejeitada: { txt: 'o comercial preferiu não usar', cor: '#6c757d', icone: 'x-circle' },
};

export default function AvisoSugestaoFoto({ sugestao }) {
  const s = sugestao && SITUACAO[sugestao.status];
  const data = sugestao?.decidida_em || sugestao?.criado_em;
  return (
    <div className="text-muted mb-2" style={{ fontSize: '0.74rem', lineHeight: 1.35 }}>
      <i className="bi bi-megaphone me-1"></i>
      Foto que você sobe e usa (ao salvar ou gerar) vai como sugestão pro cadastro do produto no Portal Comercial.
      {s && (
        <div style={{ color: s.cor }}>
          <i className={`bi bi-${s.icone} me-1`}></i>
          Última sugestão deste produto: {s.txt}
          {sugestao.decidida_por ? ` (${sugestao.decidida_por}` : ''}
          {sugestao.decidida_por && data ? `, ${new Date(data).toLocaleDateString('pt-BR')})` : sugestao.decidida_por ? ')' : ''}
        </div>
      )}
    </div>
  );
}
